import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Seo } from '../components/Seo';
import { LEGAL_CONTACT_EMAIL, LEGAL_ORG_NAME } from '../lib/legal-site-info';

export function DisclaimerPage() {
  return (
    <>
      <Seo
        path="/disclaimer"
        title="Disclaimer"
        description={`Disclaimer ${LEGAL_ORG_NAME} / ComfortTool™: indicatieve berekeningen, geen energielabel, geen vervanging van maatwerkadvies.`}
        keywords="ComfortTool disclaimer, indicatief, energielabel, scan"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Disclaimer' }]} />
        <article className="mt-6">
          <h1 className="text-3xl font-bold text-ct-text">Disclaimer</h1>
          <p className="mt-2 text-sm text-ct-muted">{LEGAL_ORG_NAME}</p>
          <div className="mt-8 space-y-6 text-sm leading-relaxed text-ct-muted">
            <section>
              <h2 className="text-lg font-bold text-ct-text">Indicatief karakter</h2>
              <p className="mt-2">
                ComfortTool levert indicatieve uitkomsten op basis van jouw invoer en algemene aannames. Het is{' '}
                <strong className="text-ct-text">geen</strong> officieel energielabel,{' '}
                <strong className="text-ct-text">geen</strong> NTA‑8800- of VABI-vervanger en{' '}
                <strong className="text-ct-text">geen</strong> vergunning- of subsidieadvies.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">Geen professioneel advies</h2>
              <p className="mt-2">
                Niets op deze site vormt bouwkundig, juridisch, financieel of medisch advies. Voor beslissingen met
                impact schakel je een erkende professional in.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">Uitgeschreven rapportteksten</h2>
              <p className="mt-2">
                Bij Comfort Plus kan een uitgebreid leesbaar rapport worden opgebouwd op basis van je invoer. Dat is
                bedoeld als hulp bij het lezen — niet als enige bron. Controleer altijd de cijfers op je scherm en laat
                keuzes toetsen door een professional op locatie.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">Contact</h2>
              <p className="mt-2">
                Vragen of correcties?{' '}
                <Link to="/contact" className="font-medium text-ct-accent hover:underline">
                  Contactpagina
                </Link>
                {LEGAL_CONTACT_EMAIL ? (
                  <>
                    {' '}
                    of{' '}
                    <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="font-medium text-ct-accent hover:underline">
                      {LEGAL_CONTACT_EMAIL}
                    </a>
                  </>
                ) : null}
                .
              </p>
            </section>
            <p className="text-xs text-ct-muted/80">
              Laat documenten nakijken door een jurist waar nodig. Zie ook{' '}
              <Link to="/voorwaarden" className="text-ct-accent hover:underline">
                algemene voorwaarden
              </Link>{' '}
              en{' '}
              <Link to="/bestelvoorwaarden" className="text-ct-accent hover:underline">
                bestelvoorwaarden
              </Link>
              .
            </p>
          </div>
        </article>
      </div>
    </>
  );
}
